import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Check, X } from 'lucide-react';

const ComparisonSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const comparisons = [
    {
      feature: 'Vollständige Abdeckung (inkl. Kleinststädte)',
      adloc: true,
      others: false
    },
    {
      feature: 'Regelmäßige Datenaktualisierung',
      adloc: true,
      others: false
    },
    {
      feature: 'Faire Credit-Preise (kein Abo-Zwang)',
      adloc: true,
      others: false
    },
    {
      feature: 'Intelligente Multi-Filter',
      adloc: true,
      others: true
    },
    {
      feature: 'E-Mail-Abdeckung bis 95%',
      adloc: true,
      others: false
    },
    {
      feature: 'Sofort-CSV-Export',
      adloc: true,
      others: true
    },
    {
      feature: 'Versteckte Kosten',
      adloc: false,
      others: true
    },
    {
      feature: 'Komplizierte Registrierung',
      adloc: false,
      others: true
    }
  ];

  return (
    <section ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Adloc vs. Andere Anbieter
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Sehen Sie selbst, warum Adloc die bessere Wahl für Ihre B2B-Lead-Generierung ist.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="max-w-4xl mx-auto"
        >
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-200">
            {/* Header */}
            <div className="grid grid-cols-3 bg-gradient-to-r from-[#2835F7] to-[#1a25c9] text-white">
              <div className="p-6">
                <h3 className="text-lg font-bold">Funktion</h3>
              </div>
              <div className="p-6 text-center border-l border-white/20">
                <h3 className="text-lg font-bold">Adloc</h3>
              </div>
              <div className="p-6 text-center border-l border-white/20">
                <h3 className="text-lg font-bold">Andere Anbieter</h3>
              </div>
            </div>

            {/* Comparison rows */}
            {comparisons.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                animate={inView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.3 + index * 0.05 }}
                className={`grid grid-cols-3 border-b border-gray-200 last:border-b-0 hover:bg-gray-50 transition-colors ${
                  index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                }`}
              >
                <div className="p-6">
                  <p className="text-gray-900 font-medium">{item.feature}</p>
                </div>
                <div className="p-6 flex items-center justify-center border-l border-gray-200">
                  {item.adloc ? (
                    <Check className="w-7 h-7 text-green-600" />
                  ) : (
                    <X className="w-7 h-7 text-red-600" />
                  )}
                </div>
                <div className="p-6 flex items-center justify-center border-l border-gray-200">
                  {item.others ? (
                    <Check className="w-7 h-7 text-green-600" />
                  ) : (
                    <X className="w-7 h-7 text-gray-400" />
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="mt-12 text-center"
        >
          <p className="text-gray-600 text-lg">
            Der Unterschied ist klar: <span className="font-bold text-[#2835F7]">Adloc bietet mehr für weniger.</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ComparisonSection;